<div class="facets-container" #facetContainer [ngClass]="{'collapsed-facets-container': collapsedContainer == true}">
  <div class="facet-actions">
    @if (collapsedContainer == false) {
      <span class="facet-actions-title">{{ translationsService.translate('WebGalis_Facets_Title') }}</span>
    }
    @if (collapsedContainer == true) {
      <span class="facet-actions-expand" (click)="expand()">
        <img src="/assets/css/images/platform/double-arrow-right.png" />
      </span>
    }
    @if (collapsedContainer == false && !loading) {
      <span class="facet-actions-collapse" (click)="collapse()">
        <img src="/assets/css/images/platform/double-arrow-left.png" />
      </span>
    }
  </div>
  @if (collapsedContainer == false) {
    <ng-scrollbar [visibility]="'hover'">
      <sem-loader [showLoader]="loading"></sem-loader>
      @for (facet of availibleFacets; track facet) {
        @if (facet.groupFacets.length > 0) {
          <div class="string-facets">
            <div class="facet-group-header" (click)="toggleFacetGroup(facet.facetPropertyPath)">
              <label>{{facet.facetTranslation?.split(' - ')[0]}}</label>
              <span class="material-symbols-outlined facet-chevron">
                {{ isFacetExpanded(facet.facetPropertyPath) ? 'expand_more' : 'chevron_right' }}
              </span>
            </div>
            @if (isFacetExpanded(facet.facetPropertyPath)) {
              <div class="facet-values">
                @for (facetGroup of facet.groupFacets; track facetGroup) {
                  <div class="facet-value-item">
                    @if (facetGroup.count > 0) {
                      <div>
                        <div class="checkbox-facet"
                          (click)="facetChanged(facetGroup.value, facet.facetPropertyPath, facet.facetType, facetGroup.facetChecked, facetGroup.start, facetGroup.end)"
                          [ngClass]="{'checkbox-facet-checked': facetGroup.facetChecked == true}">
                          <input type="checkbox" name="facetGroup.label" />
                        </div>
                        <span class="facet-value">{{translationsService.translate(facetGroup.label)}}</span>
                        <span
                        class="tooltip-text facet-label-tooltip">{{translationsService.translate(facetGroup.label)}}</span>
                        <span class="facet-count">{{facetGroup.count}}</span>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      }
    </ng-scrollbar>
  }
</div>